import React from "react";
import { Dropdown, Button } from "antd";
import { DownOutlined } from "@ant-design/icons";
import { Col } from "react-bootstrap";

function BtnClearDropdown({ onSelect, menuItems, label, disabled }) {
  const handleMenuClick = ({ key }) => {
    if (onSelect) onSelect(key);
  };

  const menu = {
    items: menuItems,
    onClick: handleMenuClick,
  };

  return (
    <div className="mt-1">
      <Col className="">
        <Dropdown menu={menu} disabled={disabled}>
          <Button 
            className="action-btn-2 clear"
            style={{ borderRadius: "4px" }}
          >
            {label} <DownOutlined />
          </Button>
        </Dropdown>
      </Col>
    </div>
  );
}

export default BtnClearDropdown;
